import { flushSync } from "react-dom";
import type { NavigateFunction } from "react-router-dom";

// Envuelve una navegación en la View Transitions API del navegador para que el cambio
// de página sea un fundido suave en vez de un corte instantáneo. Se degrada sin más
// (navegación normal) en navegadores que no la soporten.
export function navigateWithTransition(navigate: NavigateFunction, to: string) {
  if (!document.startViewTransition) {
    navigate(to);
    return;
  }
  document.startViewTransition(() => {
    flushSync(() => navigate(to));
  });
}
